import React, { useContext, useMemo } from 'react';
import {
  CaretDownFilled,
  CaretUpFilled,
  ClockCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Spin } from 'antd';

import RemoteAccessDashboardContext from '@totem/components/services/remoteAccess/v2/summary/remoteAccessDashboardContext';
import IBStatistic, {
  statisticsStyles,
} from '@totem/components/ui_components/widgets/statistic/IBStatistic';
import { isNotNull, isNull } from '@totem/utilities/common';

const styles = {
  table: {
    //borderSpacing: '16px',
  },
  firstCell: {
    paddingRight: '16px',
    width: '20%',
  },
  lastCell: {
    paddingLeft: '16px',
    width: '20%',
  },
  middleCell: {
    padding: '16px',
    width: '20%',
  },
};

const UserSummary = () => {
  const { dashboardData, organizationSummaryData, organizationSummaryLoading } =
    useContext(RemoteAccessDashboardContext);

  const totalOrgs = useMemo(() => {
    return isNotNull(organizationSummaryData)
      ? organizationSummaryData.length
      : 0;
  }, [organizationSummaryData]);

  const activeOrgs = useMemo(() => {
    return isNotNull(organizationSummaryData)
      ? organizationSummaryData.filter((chk) => chk.activeUsers > 0).length
      : 0;
  }, [organizationSummaryData]);

  if (isNull(dashboardData) || isNull(dashboardData.userSummary)) {
    return <span />;
  }

  return (
    <table width="100%" style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.firstCell}>
            <IBStatistic
              title="Total Accounts"
              subTitle={'Total Authorized Users'}
              value={dashboardData.userSummary.totalUsers}
              precision={0}
              icon={<TeamOutlined />}
              style={statisticsStyles.info}
            />
          </td>
          <td style={styles.middleCell}>
            <IBStatistic
              title="Active Accounts"
              subTitle={'Authorized, and active'}
              value={dashboardData.userSummary.currentActiveCount}
              valueSuffix={
                <span>
                  {dashboardData.userSummary.currentActiveCount >
                    dashboardData.userSummary.previousActiveCount && (
                    <CaretUpFilled
                      style={{ color: statisticsStyles.ok.color }}
                      title={`Previous: ${dashboardData.userSummary.previousActiveCount}`}
                    />
                  )}
                  {dashboardData.userSummary.currentActiveCount <
                    dashboardData.userSummary.previousActiveCount && (
                    <CaretDownFilled
                      style={{ color: statisticsStyles.critical.color }}
                      title={`Previous: ${dashboardData.userSummary.previousActiveCount}`}
                    />
                  )}
                </span>
              }
              precision={0}
              icon={<TeamOutlined />}
              style={statisticsStyles.ok}
            />
          </td>
          <td style={styles.middleCell}>
            <IBStatistic
              title="Stale Accounts"
              subTitle={'Not used in the last 90 days'}
              value={dashboardData.userSummary.currentStaleCount}
              valueSuffix={
                <span>
                  {dashboardData.userSummary.currentStaleCount >
                    dashboardData.userSummary.previousStaleCount && (
                    <CaretUpFilled
                      style={{ color: statisticsStyles.critical.color }}
                      title={`Previous: ${dashboardData.userSummary.previousStaleCount}`}
                    />
                  )}
                  {dashboardData.userSummary.currentStaleCount <
                    dashboardData.userSummary.previousStaleCount && (
                    <CaretDownFilled
                      style={{ color: statisticsStyles.ok.color }}
                      title={`Previous: ${dashboardData.userSummary.previousStaleCount}`}
                    />
                  )}
                </span>
              }
              precision={0}
              icon={<ClockCircleOutlined />}
              style={statisticsStyles.warning}
            />
          </td>
          <td style={styles.middleCell}>
            <IBStatistic
              title="Never Used"
              subTitle={'Authorized, no logins'}
              value={dashboardData.userSummary.currentNeverUsedCount}
              valueSuffix={
                <span>
                  {dashboardData.userSummary.currentNeverUsedCount >
                    dashboardData.userSummary.previousNeverUsedCount && (
                    <CaretUpFilled
                      style={{ color: statisticsStyles.critical.color }}
                      title={`Previous: ${dashboardData.userSummary.previousNeverUsedCount}`}
                    />
                  )}
                  {dashboardData.userSummary.currentNeverUsedCount <
                    dashboardData.userSummary.previousNeverUsedCount && (
                    <CaretDownFilled
                      style={{ color: statisticsStyles.ok.color }}
                      title={`Previous: ${dashboardData.userSummary.previousNeverUsedCount}`}
                    />
                  )}
                </span>
              }
              precision={0}
              icon={<CloseCircleOutlined />}
              style={statisticsStyles.critical}
            />
          </td>
          <td style={styles.lastCell}>
            <IBStatistic
              title="User Organizations"
              subTitle={'Using remote access'}
              value={
                !organizationSummaryLoading ? (
                  `${activeOrgs} of ${totalOrgs}`
                ) : (
                  <Spin
                    description={'Loading...'}
                    style={statisticsStyles.neutral}
                  />
                )
              }
              precision={0}
              style={statisticsStyles.neutral}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default UserSummary;
